import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { isGuestFoldersAffiliation } from "@Front/Utils/preferredRealOfficeUidHelpers";
import { isAdminRole } from "@Front/Utils/officeRoleStatusHelpers";

function storeShowsGuestFoldersSentinel(storeRawOfficeUid: string): boolean {
	return (
		storeRawOfficeUid === "GUEST_FOLDERS" ||
		isGuestFoldersAffiliation({ office_uid: storeRawOfficeUid, uid: storeRawOfficeUid })
	);
}

/**
 * Masquage Espace office : vue dossiers invités côté store ET pas de droit siège / admin global (inchangé métier).
 * Invité JWT (`isGuest`) : le backend met `hasActiveSubscription` à false (non requis en dossiers invités) — ne pas
 * confondre avec l'absence de siège sur l'étude.
 */
export function shouldHideGuestFolders(
	storeRawOfficeUid: string,
	permissionContext: PermissionContextDto | null | undefined,
): boolean {
	const storeShowsGuestFolders = storeShowsGuestFoldersSentinel(storeRawOfficeUid);
	if (!storeShowsGuestFolders) {
		return false;
	}
	if (permissionContext?.isGuest === true) {
		return false;
	}
	const hasSeatInStudy = permissionContext?.hasActiveSubscription !== false && permissionContext?.isVisitor !== true;
	const isAdminGlobally = isAdminRole(permissionContext?.globalRole);
	return !hasSeatInStudy && !isAdminGlobally;
}
